// import node module libraries
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Table } from 'react-bootstrap';
import {
	useFilters,
	useGlobalFilter,
	usePagination,
	useTable
} from 'react-table';

// import custom components
import GlobalFilter from 'components/elements/advance-table/GlobalFilter';
import Pagination from 'components/elements/advance-table/Pagination';

// import utility file
import { Avatar } from '../../../elements/bootstrap/Avatar';
import TypeLocalService from '../../services/TypeLocalService';

const TypeLocalsListItems = () => {
	const [originalTypeLocals, setOriginalTypeLocals] = useState([]);
	const [typeLocals, setTypeLocals] = useState([]);

	useEffect(() => {
		Promise.all([TypeLocalService.getAllTypeLocals()]).then(([typeLocalsData]) => {
			setOriginalTypeLocals(typeLocalsData);
			setTypeLocals(typeLocalsData);
		});
	}, []);

	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'type' && value) {
				return value.toUpperCase();
			}
			 else {
				return value;
			}
		}
		return value;
	};

	const getInitials = (typeLocal) => {
		const type = typeLocal.type ? typeLocal.type.charAt(0).toUpperCase() : '';
		return `${type} `;
	};

	const columns = useMemo(
		() => [
			{ accessor: 'id', Header: 'ID', show: false },
			{
				accessor: 'type',
				Header: 'Type de Local',
				Cell: ({ value, row }) => {
					const initials = getInitials(row.original);
					return (
						<div className="d-flex align-items-center">
							<Avatar
								type="initial"
								size="md"
								name={initials}
								className="rounded-circle"
								alt={initials}
							/>
							{value ? (
								<Link to={`/assets/typelocal/${row.original.id}`}>
									<h5 className="mb-0 ms-2">{formatValue(value, 'type')}</h5>
								</Link>
							) : null}
						</div>
					);
				}
			},

		],
		[]
	);

	const data = useMemo(() => {
		return typeLocals.map((typeLocal) => ({
			...typeLocal
		}));
	}, [typeLocals]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		state,
		gotoPage,
		pageCount,
		prepareRow,
		setGlobalFilter
	} = useTable(
		{
			columns,
			data,
			initialState: {
				pageSize: 10,
				hiddenColumns: columns.map((column) => {
					if (column.show === false) return column.accessor || column.id;
					else return false;
				})
			}
		},
		useFilters,
		useGlobalFilter,
		usePagination
	);

	const { pageIndex, globalFilter } = state;

	return (
		<Fragment>
			<div className="overflow-hidden p-3">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xl={2} lg={4} md={6} xs={12}>
						<GlobalFilter
							filter={globalFilter}
							setFilter={setGlobalFilter}
							placeholder="Rechercher un Type de Local"
						/>
					</Col>
				</Row>
			</div>

			<Table
				hover
				responsive
				{...getTableProps()}
				className="text-nowrap table-centered"
			>
				<thead className="table-light">
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps()}>{column.render('Header')}</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{page.map((row) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return (
										<td {...cell.getCellProps()}>{cell.render('Cell')}</td>
									);
								})}
							</tr>
						);
					})}
				</tbody>
			</Table>

			<Pagination
				previousPage={previousPage}
				pageCount={pageCount}
				pageIndex={pageIndex}
				gotoPage={gotoPage}
				nextPage={nextPage}
			/>
		</Fragment>
	);
};

export default TypeLocalsListItems;
